import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgFilePdf = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.743 4L20 7.628v10.428c0 .935-.66 1.721-1.552 1.944V9.152h-2.62a1 1 0 01-1-1V5.506h-7.24a.51.51 0 00-.518.502v6.024H5.518V6.008C5.518 4.899 6.445 4 7.588 4h8.154zM6.706 14.084a3.136 3.136 0 00-.932-.123H4v5.099h1.086v-1.754h.688c.35 0 .655-.041.916-.125a1.8 1.8 0 00.648-.35c.171-.15.3-.328.384-.537.084-.208.126-.438.126-.689 0-.236-.04-.455-.12-.657a1.346 1.346 0 00-.376-.521 1.79 1.79 0 00-.646-.343zm-.184 2.175c-.159.16-.408.239-.748.239h-.688v-1.736h.688c.169 0 .315.02.438.06.123.04.225.096.306.17.08.074.141.163.181.267.04.104.06.22.06.346 0 .277-.08.495-.237.654zm6.728.25c0 .372-.065.715-.194 1.027a2.334 2.334 0 01-.546.807 2.51 2.51 0 01-.85.527c-.33.126-.697.19-1.1.19H8.54v-5.1h2.02c.403 0 .77.064 1.1.19a2.5 2.5 0 01.85.53c.235.226.417.494.546.806.13.311.194.652.194 1.023zm-1.224-.72c.073.212.109.452.109.72 0 .269-.036.51-.109.723a1.523 1.523 0 01-.311.543 1.33 1.33 0 01-.494.341 1.753 1.753 0 01-.66.118h-.928v-3.447h.927c.246 0 .466.04.66.12.195.079.36.192.495.34.135.148.239.328.311.541zm3.117-1.002v1.409h1.89v.829h-1.89v2.035H14.05v-5.1h3.345v.827h-2.252z"
      clipRule="evenodd"
    />
  </svg>
));
SvgFilePdf.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgFilePdf;
